import {Link} from "react-router-dom";
import React from "react";

export const OpenbrainLogoLink = () => (
  <Link to={"www.openbrain.io"} style={{fontSize: 12,textDecoration: "none", color: "#252525"}}><img src={"/logo-black.svg"} alt={"logo"} width={100}/></Link>
)